import { useAuthIdentity } from '@webbyx/next-js';

import { hasAccess } from './helpers';

/**
 * ===========================
 * MAIN
 * ===========================
 */

export const usePermissionsHook = () => {
  const { authUser } = useAuthIdentity();

  // const checked = useMemo(() => {
  //   return hasAccess(authUser, permissions);
  // }, [authUser, permissions]);

  return {
    isGranted: (permissions: string[]) => {
      return hasAccess(authUser, permissions);
    },
  };
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default usePermissionsHook;
